/* Survey Engine v1 — Laqqua
 * Player dei sondaggi costruiti dalla dashboard (sezione "Sondaggi").
 * Definizione letta a runtime da survey-public (?slug=), una domanda per
 * schermata come il quiz, risposte salvate con UPSERT PROGRESSIVO: la riga
 * su survey_response nasce al primo "Inizia" e si aggiorna a ogni step, così
 * anche chi molla a metà lascia il punto esatto in cui si è fermato.
 *
 * Tipi domanda: single | multi (max_choices) | scale (0-10) | text | textarea
 *               | email | section (schermata di transizione senza input)
 * Branching: show_if {question_id, equals} → lo step esiste solo se la
 * risposta combacia (le risposte di rami abbandonati vengono ripulite).
 * Codice sconto: MAI nella GET; lo restituisce il POST di completamento.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-survey-engine]');
  if (!root) return;

  var stage = root.querySelector('[data-survey-stage]');
  var progressWrap = root.querySelector('[data-survey-progress-wrap]');
  var progressBar = root.querySelector('[data-survey-progress-bar]');
  var stepMarker = root.querySelector('[data-survey-step-marker]');

  var ENDPOINT = root.dataset.surveyEndpoint;
  var params = new URLSearchParams(window.location.search);
  var SLUG = (params.get('s') || root.dataset.surveyDefaultSlug || '').trim();
  var PREVIEW = params.get('anteprima') === '1';

  var SURVEY = null;
  var PRODUCTS = [];
  try {
    var prodNode = root.querySelector('script[data-survey-products]');
    if (prodNode) PRODUCTS = JSON.parse(prodNode.textContent) || [];
  } catch (e) {}
  var state = {
    screen: 'intro',      // intro | step | done | closed
    i: 0,                 // indice nello steps() correnti
    answers: {},          // question_id -> string | string[] | number
    other: {},            // question_id -> testo campo "Altro"
    startedAt: null,
    discountCode: null,
    emailed: false,       // il server ha innescato l'invio email del codice
    applied: null         // null = auto-apply in corso/non fatto, true/false esito
  };
  var responseId = null;
  var isInitialLoad = true;

  /* ---------- Utils ---------- */
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  var storeKey = 'laqqua_survey_' + SLUG;
  function saveLocal() {
    try {
      sessionStorage.setItem(storeKey, JSON.stringify({
        responseId: responseId, answers: state.answers, other: state.other,
        i: state.i, screen: state.screen, startedAt: state.startedAt
      }));
    } catch (e) {}
  }
  function loadLocal() {
    try { return JSON.parse(sessionStorage.getItem(storeKey) || 'null'); } catch (e) { return null; }
  }
  function scrollTop() {
    if (isInitialLoad) return;
    if (window.pageYOffset < 8) return;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  function track(event, payload) {
    payload = Object.assign({ survey: SLUG }, payload || {});
    try { if (window.umami && window.umami.track) window.umami.track(event, payload); } catch (e) {}
    try { if (window.dataLayer && window.dataLayer.push) window.dataLayer.push(Object.assign({ event: event }, payload)); } catch (e) {}
  }

  /* ---------- Steps visibili (branching) ---------- */
  function visible(q) {
    if (!q.show_if || !q.show_if.question_id) return true;
    return state.answers[q.show_if.question_id] === q.show_if.equals;
  }
  function steps() {
    return (SURVEY.questions || []).filter(visible);
  }
  // Numerazione: solo le domande vere (le schermate 'section' non contano).
  function questionNumber(list, idx) {
    var n = 0;
    for (var k = 0; k <= idx && k < list.length; k++) if (list[k].type !== 'section') n++;
    return n;
  }
  function questionsTotal(list) {
    return list.filter(function (q) { return q.type !== 'section'; }).length;
  }

  /* ---------- Sync col server ---------- */
  function collectMeta() {
    var utm = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
      if (params.get(k)) utm[k] = params.get(k);
    });
    return {
      source: params.get('src') || (Object.keys(utm).length ? 'utm' : 'link'),
      utm: Object.keys(utm).length ? utm : null,
      referrer: document.referrer || null,
      device: (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) ? 'mobile' : 'desktop'
    };
  }
  function cleanAnswers() {
    // Tiene solo le risposte di step ancora visibili (se torni indietro e cambi
    // ramo, le risposte del ramo abbandonato non devono sporcare i dati).
    var keep = {};
    steps().forEach(function (q) {
      if (q.type === 'section') return;
      if (state.answers[q.id] !== undefined && state.answers[q.id] !== null && state.answers[q.id] !== '') {
        keep[q.id] = withOther(q, state.answers[q.id]);
      }
    });
    return keep;
  }
  function withOther(q, val) {
    // "Altro" → "Altro: <testo libero>" così l'aggregazione in dashboard può
    // raggruppare e insieme leggere i testi.
    var otherText = (state.other[q.id] || '').trim();
    function map(v) { return v === '__other__' ? (otherText ? 'Altro: ' + otherText : 'Altro') : v; }
    if (Array.isArray(val)) return val.map(map);
    return map(val);
  }
  function sync(completed, cb) {
    if (!SURVEY || !responseId) return;
    var list = steps();
    var meta = collectMeta();
    var emailQ = list.filter(function (q) { return q.type === 'email'; })[0];
    var payload = {
      survey_id: SURVEY.id,
      response_id: responseId,
      answers: cleanAnswers(),
      email: emailQ ? (state.answers[emailQ.id] || null) : null,
      completed: !!completed,
      last_step: Math.min(state.i + 1, list.length),
      steps_total: list.length,
      duration_ms: state.startedAt ? (Date.now() - state.startedAt) : null,
      source: meta.source,
      utm: meta.utm,
      referrer: meta.referrer,
      device: meta.device,
      started_at: state.startedAt ? new Date(state.startedAt).toISOString() : null
    };
    var done = false;
    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true
    }).then(function (r) { return r.json(); }).then(function (j) {
      if (done) return; done = true;
      if (cb) cb(j || {});
    }).catch(function () {
      if (done) return; done = true;
      if (cb) cb({});
    });
    // Il salvataggio di avanzamento è fire-and-forget; solo il completamento
    // aspetta la risposta (serve il discount_code).
  }

  /* ---------- Progress ---------- */
  function updateProgress() {
    var list = steps();
    var total = questionsTotal(list);
    if (state.screen !== 'step' || !total) {
      progressWrap.hidden = state.screen !== 'step';
      return;
    }
    progressWrap.hidden = false;
    var num = questionNumber(list, state.i);
    var answeredPct = Math.max(6, Math.min(97, Math.round(((num - 1) / total) * 100)));
    progressBar.style.width = answeredPct + '%';
    stepMarker.textContent = num + ' / ' + total;
    stepMarker.style.left = Math.max(6, Math.min(94, answeredPct)) + '%';
  }

  /* ---------- Render ---------- */
  function render() {
    updateProgress();
    if (state.screen === 'intro') renderIntro();
    else if (state.screen === 'step') renderStep();
    else if (state.screen === 'done') renderDone();
    else if (state.screen === 'closed') renderClosed();
    isInitialLoad = false;
    saveLocal();
  }

  function renderIntro() {
    var intro = SURVEY.intro || {};
    var html = '<div class="quiz-step survey-intro" data-step="_intro">';
    html += '<h1 class="quiz-engine__heading">' + esc(intro.heading || SURVEY.title) + '</h1>';
    if (intro.subheading) html += '<p class="quiz-engine__sub">' + esc(intro.subheading) + '</p>';
    var bullets = intro.bullets || [];
    if (bullets.length) {
      html += '<div class="survey-intro__bullets">';
      bullets.forEach(function (b) {
        html += '<div class="survey-intro__bullet">';
        if (b.icon) html += '<span class="survey-intro__bullet-icon" aria-hidden="true">' + esc(b.icon) + '</span>';
        html += '<span class="survey-intro__bullet-body">';
        if (b.title) html += '<strong>' + esc(b.title) + '</strong> ';
        html += esc(b.text || '') + '</span></div>';
      });
      html += '</div>';
    }
    html += '<div class="quiz-step__nav quiz-step__nav--center">';
    html += '<button type="button" class="quiz-btn quiz-btn--lg" data-survey-start>Inizia il sondaggio</button>';
    html += '</div></div>';
    stage.innerHTML = html;
    stage.querySelector('[data-survey-start]').addEventListener('click', function () {
      if (!responseId) responseId = uuid();
      if (!state.startedAt) state.startedAt = Date.now();
      state.screen = 'step';
      state.i = 0;
      track('survey_start');
      sync(false);
      render();
      scrollTop();
    });
  }

  function currentAnswerValid(q) {
    var v = state.answers[q.id];
    if (q.type === 'section') return true;
    if (!q.required) return true;
    if (q.type === 'multi') return Array.isArray(v) && v.length > 0;
    if (q.type === 'scale') return typeof v === 'number';
    if (q.type === 'email') return typeof v === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
    return v !== undefined && v !== null && String(v).trim() !== '';
  }

  function renderStep() {
    var list = steps();
    if (state.i >= list.length) { finish(); return; }
    var q = list[state.i];
    var isSection = q.type === 'section';
    var html = '<div class="quiz-step' + (isSection ? ' quiz-step--transition' : '') + '" data-step="' + esc(q.id) + '">';
    html += '<h2 class="quiz-step__question" id="surveyQ-' + esc(q.id) + '">' + esc(q.label) + '</h2>';
    var sub = q.subtitle || '';
    if (!q.required && !isSection && q.type !== 'section' && !/facoltativ/i.test(sub)) {
      sub = sub ? sub + ' Facoltativa.' : 'Facoltativa.';
    }
    if (sub) html += '<p class="quiz-step__subtitle">' + esc(sub) + '</p>';

    if (q.type === 'single' || q.type === 'multi') {
      var isMulti = q.type === 'multi';
      var opts = (q.options || []).slice();
      var vals = opts.map(function (o) { return o; });
      if (q.allow_other) vals.push('__other__');
      var current = state.answers[q.id];
      var selected = isMulti ? (Array.isArray(current) ? current : []) : [current];
      var single = vals.length <= 4;
      html += '<div class="quiz-step__options' + (single ? ' quiz-step__options--single-col' : '') + '" data-multi="' + isMulti + '" role="' + (isMulti ? 'group' : 'radiogroup') + '" aria-labelledby="surveyQ-' + esc(q.id) + '">';
      vals.forEach(function (v, i) {
        var label = v === '__other__' ? 'Altro' : v;
        var checked = selected.indexOf(v) !== -1;
        html += '<button type="button" class="quiz-option" data-val="' + esc(v) + '" role="' + (isMulti ? 'checkbox' : 'radio') + '" aria-checked="' + checked + '">';
        html += '<span class="quiz-option__label"><span class="quiz-option__label-main">' + esc(label) + '</span></span>';
        html += '<span class="quiz-option__check" aria-hidden="true"></span>';
        html += '</button>';
      });
      html += '</div>';
      var showOther = selected.indexOf('__other__') !== -1;
      html += '<div class="survey-other" data-survey-other ' + (showOther ? '' : 'hidden') + '>';
      html += '<input type="text" class="quiz-lead__input survey-other__input" placeholder="Scrivi qui…" maxlength="200" value="' + esc(state.other[q.id] || '') + '">';
      html += '</div>';
    } else if (q.type === 'scale') {
      var mn = q.scale_min != null ? q.scale_min : 0;
      var mx = q.scale_max != null ? q.scale_max : 10;
      html += '<div class="survey-scale" role="radiogroup" aria-labelledby="surveyQ-' + esc(q.id) + '">';
      for (var n = mn; n <= mx; n++) {
        var on = state.answers[q.id] === n;
        html += '<button type="button" class="survey-scale__chip" role="radio" aria-checked="' + on + '" data-scale="' + n + '">' + n + '</button>';
      }
      html += '</div>';
      if (q.min_label || q.max_label) {
        html += '<div class="survey-scale__labels"><span>' + esc(q.min_label || '') + '</span><span>' + esc(q.max_label || '') + '</span></div>';
      }
    } else if (q.type === 'text' || q.type === 'email') {
      html += '<div class="survey-field">';
      html += '<input type="' + (q.type === 'email' ? 'email' : 'text') + '" class="quiz-lead__input survey-field__input" maxlength="320" ' +
        (q.type === 'email' ? 'autocomplete="email" placeholder="nome.cognome@email.com"' : 'placeholder="Scrivi qui…"') +
        ' value="' + esc(state.answers[q.id] || '') + '">';
      html += '<p class="survey-field__error" data-survey-error hidden>Inserisci un indirizzo email valido.</p>';
      html += '</div>';
    } else if (q.type === 'textarea') {
      html += '<div class="survey-field">';
      html += '<textarea class="quiz-lead__input survey-field__textarea" rows="4" maxlength="2000" placeholder="Scrivi qui…">' + esc(state.answers[q.id] || '') + '</textarea>';
      html += '</div>';
    }

    var hasBack = state.i > 0;
    var lastQ = state.i === list.length - 1;
    html += '<div class="quiz-step__nav' + (isSection ? ' quiz-step__nav--center' : (hasBack ? '' : ' quiz-step__nav--single')) + '">';
    if (hasBack) html += '<button type="button" class="quiz-btn quiz-btn--ghost" data-survey-back>Indietro</button>';
    html += '<button type="button" class="quiz-btn" data-survey-next' + (currentAnswerValid(q) ? '' : ' disabled') + '>' +
      (isSection ? 'Avanti' : (lastQ ? 'Concludi' : 'Continua')) + '</button>';
    html += '</div></div>';

    stage.innerHTML = html;
    wireStep(q);
  }

  function wireStep(q) {
    var nextBtn = stage.querySelector('[data-survey-next]');
    var backBtn = stage.querySelector('[data-survey-back]');

    function refreshNext() {
      if (nextBtn) nextBtn.disabled = !currentAnswerValid(q);
    }

    if (q.type === 'single' || q.type === 'multi') {
      var isMulti = q.type === 'multi';
      var otherWrap = stage.querySelector('[data-survey-other]');
      var otherInput = otherWrap ? otherWrap.querySelector('input') : null;
      stage.querySelectorAll('.quiz-option').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = btn.dataset.val;
          if (isMulti) {
            var arr = Array.isArray(state.answers[q.id]) ? state.answers[q.id].slice() : [];
            var at = arr.indexOf(v);
            if (at !== -1) arr.splice(at, 1);
            else {
              if (q.max_choices && arr.length >= q.max_choices) {
                // limite raggiunto: feedback visivo veloce, nessuna selezione
                btn.classList.add('survey-option--deny');
                setTimeout(function () { btn.classList.remove('survey-option--deny'); }, 350);
                return;
              }
              arr.push(v);
            }
            state.answers[q.id] = arr;
            btn.setAttribute('aria-checked', String(at === -1));
          } else {
            state.answers[q.id] = v;
            stage.querySelectorAll('.quiz-option').forEach(function (b) {
              b.setAttribute('aria-checked', String(b === btn));
            });
          }
          var otherOn = isMulti
            ? (state.answers[q.id] || []).indexOf('__other__') !== -1
            : state.answers[q.id] === '__other__';
          if (otherWrap) {
            otherWrap.hidden = !otherOn;
            if (otherOn && otherInput) otherInput.focus();
          }
          refreshNext();
          saveLocal();
          // Su scelta singola senza "Altro" selezionato: avanza da solo dopo
          // un attimo, come il quiz (meno tap su mobile).
          if (!isMulti && !otherOn) setTimeout(goNext, 220);
        });
      });
      if (otherInput) otherInput.addEventListener('input', function () {
        state.other[q.id] = otherInput.value;
        saveLocal();
      });
    } else if (q.type === 'scale') {
      stage.querySelectorAll('.survey-scale__chip').forEach(function (chip) {
        chip.addEventListener('click', function () {
          state.answers[q.id] = parseInt(chip.dataset.scale, 10);
          stage.querySelectorAll('.survey-scale__chip').forEach(function (c) {
            c.setAttribute('aria-checked', String(c === chip));
          });
          refreshNext();
          saveLocal();
          setTimeout(goNext, 220);
        });
      });
    } else {
      var input = stage.querySelector('.survey-field__input, .survey-field__textarea');
      if (input) {
        input.addEventListener('input', function () {
          state.answers[q.id] = input.value;
          var err = stage.querySelector('[data-survey-error]');
          if (err) err.hidden = true;
          input.removeAttribute('aria-invalid');
          refreshNext();
          saveLocal();
        });
        // Email scritta male → errore esplicito appena si lascia il campo
        // (il solo bottone disabilitato non spiega il perché).
        if (q.type === 'email') {
          input.addEventListener('blur', function () {
            if (input.value.trim() !== '' && !currentAnswerValid(q)) {
              var err = stage.querySelector('[data-survey-error]');
              if (err) err.hidden = false;
              input.setAttribute('aria-invalid', 'true');
            }
          });
        }
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' && q.type !== 'textarea') { e.preventDefault(); goNext(); }
        });
        if (!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches)) input.focus();
      }
    }

    function goNext() {
      if (!currentAnswerValid(q)) {
        if (q.type === 'email') {
          var err = stage.querySelector('[data-survey-error]');
          if (err) err.hidden = false;
        }
        return;
      }
      var list = steps();
      if (state.i >= list.length - 1) { finish(); return; }
      state.i += 1;
      if (q.type !== 'section') track('survey_step', { step: q.id });
      sync(false);
      render();
      scrollTop();
    }
    function goBack() {
      if (state.i === 0) return;
      state.i -= 1;
      render();
      scrollTop();
    }
    if (nextBtn) nextBtn.addEventListener('click', goNext);
    if (backBtn) backBtn.addEventListener('click', goBack);
  }

  // Applica il codice al carrello via /discount/<code>: Shopify salva il
  // codice in un cookie e lo pre-compila al checkout. Fire-and-forget con esito.
  //
  // ⚠️ SUL CARRELLO GIÀ PIENO NON BASTA (segnalato il 2026-08-09: «il banner
  // diceva che il codice era attivo ma nel carrello non c'era»). Il cookie lo
  // legge Shopify quando RICALCOLA il carrello: se il carrello è stato
  // costruito prima, resta quello di prima — con i suoi totali senza sconto —
  // finché qualcosa non lo tocca. Quindi subito dopo si forza un ricalcolo
  // silenzioso con `/cart/update.js` (una scrittura innocua: un attributo) e
  // si avvisa il tema, così un eventuale carrello a tendina già montato si
  // ridisegna con lo sconto dentro. Se il carrello è vuoto non serve.
  function refreshCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.item_count) return null;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ attributes: { _sondaggio_sconto: String(Date.now()) } })
        }).then(function (r) { return r.ok ? r.json() : null; });
      })
      .then(function (cart) {
        if (!cart) return;
        // I temi ascoltano nomi diversi: si lanciano quelli noti, chi non li
        // usa li ignora. Nessuno di questi ricarica la pagina.
        ['cart:refresh', 'cart:updated', 'cart:build', 'cart:change'].forEach(function (nome) {
          document.dispatchEvent(new CustomEvent(nome, { bubbles: true, detail: { cart: cart } }));
        });
      })
      .catch(function () { /* il codice resta comunque valido al checkout */ });
  }

  function applyDiscount(code, cb) {
    fetch('/discount/' + encodeURIComponent(code), { redirect: 'follow', credentials: 'same-origin' })
      .then(function (r) { if (r.ok) refreshCart(); cb(r.ok); })
      .catch(function () { cb(false); });
  }

  function finish() {
    state.screen = 'done';
    track('survey_complete');
    renderDoneLoading();
    sync(true, function (j) {
      state.discountCode = j.discount_code || null;
      state.emailed = j.emailed === true;
      if (state.discountCode) {
        applyDiscount(state.discountCode, function (ok) {
          state.applied = ok;
          render();
        });
      } else {
        render();
      }
    });
  }

  function renderDoneLoading() {
    stage.innerHTML = '<div class="survey-loading"><span class="survey-loading__dot"></span><span class="survey-loading__dot"></span><span class="survey-loading__dot"></span></div>';
    updateProgress();
  }

  function answeredEmail() {
    var list = steps();
    for (var k = 0; k < list.length; k++) {
      if (list[k].type === 'email' && state.answers[list[k].id]) return state.answers[list[k].id];
    }
    return null;
  }

  var CHECK_ICON = '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><path d="M2.5 8.5l3.5 3.5 7-7.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var COPY_ICON = '<svg viewBox="0 0 20 20" width="15" height="15" aria-hidden="true"><rect x="7.2" y="7.2" width="9.3" height="10.6" rx="2.3" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M12.8 4.2H5.8A2.1 2.1 0 0 0 3.7 6.3v7.2" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

  var SEAL_ICON = '<svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true"><path d="M4.5 12.6l4.6 4.6L19.5 6.9" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function renderDone() {
    var outro = SURVEY.outro || {};
    var html = '<div class="quiz-step quiz-step--transition survey-done" data-step="_done">';
    // Bollino di conferma sopra il titolo: dice «fatto» prima ancora di leggere.
    html += '<div class="survey-done__seal" aria-hidden="true">' + SEAL_ICON + '</div>';
    html += '<h2 class="quiz-step__question">' + esc(outro.heading || 'Grazie!') + '</h2>';
    if (outro.message) html += '<p class="quiz-step__subtitle">' + esc(outro.message) + '</p>';

    if (state.discountCode) {
      html += '<div class="survey-code">';
      html += '<span class="survey-code__value" data-survey-code>' + esc(state.discountCode) + '</span>';
      // Stato applicazione: auto-apply già tentato in finish(). Da applicato è
      // un BADGE ben visibile (lo sconto è già a posto: il resto è secondario).
      var check = CHECK_ICON;
      // Stato e copia sulla stessa riga: il badge dice l'essenziale, la copia
      // è un'iconcina di servizio alla sua destra (2026-08-15).
      html += '<div class="survey-code__line">';
      if (state.applied === true) {
        html += '<p class="survey-code__badge" data-survey-status>' + check + '<span>Sconto già attivo al checkout</span></p>';
      } else {
        html += '<p class="survey-code__status" data-survey-status>Applicalo ora al carrello, o copialo per il checkout</p>';
      }
      html += '<button type="button" class="survey-code__copy" data-survey-copy aria-label="Copia codice" title="Copia codice">' + COPY_ICON + '</button>';
      html += '</div>';
      if (state.applied !== true) {
        html += '<div class="survey-code__actions">';
        html += '<button type="button" class="quiz-btn survey-code__btn" data-survey-apply>Applica al carrello</button>';
        html += '</div>';
      }
      var mail = answeredEmail();
      if (state.emailed && mail) {
        html += '<p class="survey-code__mailnote">Te l\'abbiamo inviato anche via email a <strong>' + esc(mail) + '</strong></p>';
      }
      if (SURVEY.discount_note) html += '<p class="survey-code__note">' + esc(SURVEY.discount_note) + '</p>';
      html += '</div>';
    }

    if (PRODUCTS.length) {
      html += '<div class="survey-carousel">';
      html += '<p class="survey-carousel__heading">I nostri best seller</p>';
      html += '<div class="survey-carousel__track">';
      PRODUCTS.forEach(function (p) {
        html += '<a class="survey-carousel__card" href="' + esc(p.url) + '">';
        html += '<span class="survey-carousel__imgwrap"><img class="survey-carousel__img" src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy"></span>';
        html += '<span class="survey-carousel__title">' + esc(p.title) + '</span>';
        html += '<span class="survey-carousel__price">' + esc(p.price);
        if (p.compare_at) html += ' <s class="survey-carousel__compare">' + esc(p.compare_at) + '</s>';
        html += '</span></a>';
      });
      html += '</div></div>';
    }

    html += '<div class="quiz-step__nav quiz-step__nav--center">';
    html += '<a class="quiz-btn quiz-btn--lg" href="/collections/all">Vai al catalogo</a>';
    html += '</div></div>';
    stage.innerHTML = html;

    var copyBtn = stage.querySelector('[data-survey-copy]');
    if (copyBtn) copyBtn.addEventListener('click', function () {
      var code = state.discountCode || '';
      function okFeedback() {
        copyBtn.innerHTML = CHECK_ICON;
        copyBtn.classList.add('survey-code__copy--done');
        copyBtn.setAttribute('aria-label', 'Codice copiato');
        copyBtn.setAttribute('title', 'Codice copiato');
        setTimeout(function () {
          copyBtn.innerHTML = COPY_ICON;
          copyBtn.classList.remove('survey-code__copy--done');
          copyBtn.setAttribute('aria-label', 'Copia codice');
          copyBtn.setAttribute('title', 'Copia codice');
        }, 2000);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(okFeedback).catch(function () {});
      } else {
        var ta = document.createElement('textarea');
        ta.value = code; document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); okFeedback(); } catch (e) {}
        document.body.removeChild(ta);
      }
    });
    var applyBtn = stage.querySelector('[data-survey-apply]');
    if (applyBtn) applyBtn.addEventListener('click', function () {
      applyBtn.disabled = true;
      applyBtn.textContent = 'Applico…';
      applyDiscount(state.discountCode, function (ok) {
        state.applied = ok;
        if (ok) {
          renderDone();
        } else {
          applyBtn.disabled = false;
          applyBtn.textContent = 'Riprova ad applicare';
          var st = stage.querySelector('[data-survey-status]');
          if (st) st.textContent = 'Non siamo riusciti ad applicarlo in automatico: copialo e usalo al checkout.';
        }
      });
    });
    try { sessionStorage.removeItem(storeKey); } catch (e) {}
  }

  function renderClosed() {
    stage.innerHTML = '<div class="quiz-step quiz-step--transition" data-step="_closed">' +
      '<h2 class="quiz-step__question">Questo sondaggio è chiuso</h2>' +
      '<p class="quiz-step__subtitle">Grazie comunque dell\'interesse! Dai un\'occhiata al catalogo, o torna a trovarci presto.</p>' +
      '<div class="quiz-step__nav quiz-step__nav--center"><a class="quiz-btn" href="/collections/all">Vai al catalogo</a></div></div>';
  }

  function renderError(msg) {
    stage.innerHTML = '<div class="quiz-step quiz-step--transition" data-step="_error">' +
      '<h2 class="quiz-step__question">Ops, qualcosa non va</h2>' +
      '<p class="quiz-step__subtitle">' + esc(msg || 'Non riusciamo a caricare il sondaggio. Riprova tra poco.') + '</p>' +
      '<div class="quiz-step__nav quiz-step__nav--center"><a class="quiz-btn quiz-btn--ghost" href="/">Torna alla home</a></div></div>';
  }

  /* ---------- Boot ---------- */
  if (!SLUG) { renderError('Sondaggio non specificato.'); return; }
  var url = ENDPOINT + '?slug=' + encodeURIComponent(SLUG) + (PREVIEW ? '&preview=1' : '');
  fetch(url).then(function (r) {
    if (r.status === 404) throw new Error('not_found');
    if (!r.ok) throw new Error('http');
    return r.json();
  }).then(function (j) {
    SURVEY = j.survey;
    if (!SURVEY || !Array.isArray(SURVEY.questions)) throw new Error('bad');
    if (SURVEY.status === 'closed') { state.screen = 'closed'; render(); return; }
    var saved = loadLocal();
    if (saved && saved.responseId && saved.screen === 'step') {
      responseId = saved.responseId;
      state.answers = saved.answers || {};
      state.other = saved.other || {};
      state.startedAt = saved.startedAt || Date.now();
      state.i = Math.min(saved.i || 0, Math.max(0, steps().length - 1));
      state.screen = 'step';
    }
    render();
  }).catch(function (e) {
    if (e && e.message === 'not_found') renderError('Questo sondaggio non esiste più o non è ancora attivo.');
    else renderError();
  });
})();
